import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';
import { jsConfigAppBar, registerWindowFn } from '@/utils/bridge';
import { useMounted } from '@/utils/hooks';
import { jumpToPageByH5 } from '@/utils/fn';

const RecommendPageWrapper = ({ children, title }) => {
  const configNavtiveBar = () => {
    const actionsArr = [
      {
        action_text: '运营商奖励',
        action_callback: 'jumpToIsp',
      },
      { action_text: '地区奖励', action_callback: 'jumpToRegion' },
    ];
    const data = {
      style: 1,
      trailing: {
        registed: 0,
        actions: actionsArr,
      },
      title: { text: title },
    };
    jsConfigAppBar(data);
  };

  const jumpToIsp = () => {
    jumpToPageByH5('/recommend/isp');
  };
  const jumpToRegion = () => {
    jumpToPageByH5('/recommend/region');
  };

  useMounted(() => {
    window.scrollTo(0, 0);
    configNavtiveBar();
    registerWindowFn('jumpToIsp', jumpToIsp);
    registerWindowFn('jumpToRegion', jumpToRegion);
  });

  return (
    <DocumentTitle title={title}>
      <Fragment>{children}</Fragment>
    </DocumentTitle>
  );
};
export default RecommendPageWrapper;
